import { addAllFormulas, stripAllFormulas } from './formula';

const createReducer =
  (methods: Array<(text: string) => string>) => (text: string) =>
    methods.reduce((aggregator, method) => method(aggregator), text);

const insertEmbed = createReducer([addAllFormulas]);
const removeEmbed = createReducer([stripAllFormulas]);

export { insertEmbed, removeEmbed };
